import { TENANT_USAGE_TYPE_LABELS } from 'ComponentLibrary/src/common/tenant'
import type { TenantBreakdownTableCopy } from 'ComponentLibrary/src/widgets/TenantTables/TenantSummaryTables/TenantBreakdownTable'

export const germanTenantSummaryCopy: TenantBreakdownTableCopy = {
    headers: {
        usageType: 'Nutzungsart',
        areaAndUnits: 'Flächen und Einheiten',
        vacancy: 'Leerstand',
        contractRent: 'Vertragsmiete',
        marketRent: 'Marktübliche Miete',
        delta: 'Delta',
    },
    usageTypeLabels: TENANT_USAGE_TYPE_LABELS,
    getUnitLabel: (_count, isParking) => (isParking ? 'Stpl.' : 'EH'),
    monetaryUnits: {
        perYear: '/Jahr',
        perSquareMeterPerMonth: '/m² p.M.',
        perUnitPerMonth: '/EH p.M.',
        perParkingSpacePerMonth: '/Stpl. p.M.',
    },
}
